/**
 * sectors.js — Lista compartilhada de "Ramos de Especialização" /
 * setores de atuação. Reaproveitada por:
 *   • Cadastro/edição de Apoiador Premium (ramoEspecializacao)
 *   • Filtro de Apoiadores compatíveis no painel da empresa
 *   • Possíveis filtros futuros em listagens públicas.
 */

const SECTORS = [
  "Tecnologia",
  "Saúde",
  "Educação",
  "Indústria",
  "Comércio e Varejo",
  "Serviços Financeiros",
  "Construção Civil",
  "Agronegócio",
  "Alimentos e Bebidas",
  "Logística e Transporte",
  "Energia",
  "Telecomunicações",
  "Mídia e Entretenimento",
  "Turismo e Hospitalidade",
  "Recursos Humanos",
  "Direito",
  "Consultoria Empresarial",
  "Marketing e Publicidade",
  "Imobiliário",
  "Setor Público",
  "ONGs e Terceiro Setor",
  "Outros",
];

export default SECTORS;
